import { render, staticRenderFns } from "./user_record.vue?vue&type=template&id=0f4702e6&scoped=true"
import script from "./user_record.vue?vue&type=script&lang=js"
export * from "./user_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4702e6",
  null
  
)

export default component.exports